import React from "react"
import PropTypes from "prop-types"
import styles from "./styles.css"
import ReactModal from "react-modal"

ReactModal.setAppElement("#main")

function getParent() {
  return document.querySelector("#main")
}

const Loading = (props) => (
  <ReactModal
    isOpen={props.isOpen}
    className={styles.modal}
    overlayClassName={styles.overlay_opacity}
    parentSelector={getParent}
  ></ReactModal>
)

Loading.propTypes = {
  isOpen: PropTypes.bool
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingOpacity.js